import script from "./AddOfflineBankAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOfflineBankAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddOfflineBankAccountPage.vue?vue&type=style&index=0&id=221e1e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221e1e7e"]])

export default __exports__